/* RESPONSIBLE TEAM: team-knowledge-foundations */

import ApplicationAdapter from '../application';

export default class ArticleContentReview extends ApplicationAdapter {
  pathForType() {
    return 'article_content_reviews';
  }
}
